module.exports = __webpack_public_path__ + "static/media/header_xglobal.06cc1ed5.jpg";